/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AlwaysUpdatePiiWithLtiSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ALWAYS_UPDATE_PII_WITH_LTI')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AlwaysUpdatePiiWithLtiSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AlwaysUpdatePiiWithLtiSettingParser.decode(input).map(res => new AlwaysUpdatePiiWithLtiSetting(res));
    }
    static unsafeDecode(input) {
        return AlwaysUpdatePiiWithLtiSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AlwaysUpdatePiiWithLtiSettingParser.encode(data);
    }
    static schema() {
        return AlwaysUpdatePiiWithLtiSettingParser.schema();
    }
}
